// https://router.vuejs.org/en/

import Vue from "vue";
import Router from "vue-router";

import UserProfile from "../views/UserProfile";

import WelcomeView from "../views/WelcomeView";
import AddPointView from "../views/AddPointView";

Vue.use(Router);

// This array is a list of all the active years
// Add the next one at the end in the format YYYY-#, e.g. 2018-1, 2018-2
const availableYears = ["2018-1", "2019-1", "2019-2", "2020-1"];
const latestYear = availableYears[availableYears.length - 1];

const router = new Router({
  mode: "hash",
  routes: [
    { path: "/", redirect: `/group/${latestYear}` },
    { path: "/group/:year", component: WelcomeView, name: "browse" },
    {
      path: "/group/:year/profile/:id",
      component: UserProfile,
      name: "profile"
    },
    { path: "/group/:year/add", component: AddPointView, name: "add-point" }
  ]
});

router.beforeEach((to, from, next) => {
  const year = to.params.year;
  // If an inactive year is accessed, push them to the latest year
  if (!availableYears.includes(year)) {
    next(`/group/${latestYear}`);
  }
  // Otherwise let them access that year
  else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./source/js/router.js